import IconLikeSvg from "./assets/IconLikeSvg";
import { LikeTrackBtn as StyledLikeTrackBtn } from "./styled";

export const LikeTrackBtn = ({ onClick, like, withBgColor }) => {
  return (
    <StyledLikeTrackBtn like={like} onClick={onClick} withBgColor={withBgColor}>
      <IconLikeSvg />
    </StyledLikeTrackBtn>
  );
};
